import axios from "axios";
import Cookies from "js-cookie";
import { baseApiUrl } from "../env";
const baseUrl = `${baseApiUrl}/api/v1/`;
// axiosInstance بدون withCredentials
const axiosInstance = axios.create({
  baseURL: baseUrl,
  headers: {
    "Content-Type": "application/json",
    "Cache-Control": "no-cache",
    Pragma: "no-cache",
    Expires: "0",
  },
});
// یک instance جداگانه فقط برای refresh
const authAxios = axios.create({
  baseURL: baseUrl,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// Request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    const collectionId = Cookies.get("collectionId");
    if (collectionId) {
      config.headers["Authorization"] = "";
      config.headers["collectionId"] = collectionId;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

let isRefreshing = false;
let failedQueue = [];

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const originalRequest = error.config;
    if (error.response.status === 302) {
      redirectToHome();
    }
    if (error.response.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        // If a refresh is already in progress, queue the original request
        return new Promise(function (resolve, reject) {
          failedQueue.push({ resolve, reject });
        })
          .then((collectionId) => {
            originalRequest.headers["collectionId"] = collectionId;

            return axiosInstance(originalRequest);
          })
          .catch((err) => {
            return Promise.reject(err);
          });
      }

      originalRequest._retry = true;
      isRefreshing = true;
    //   const token = "";
    //  // const refToken = localStorage.getItem("refreshToken");
    //   const refToken= Cookies.get("refreshToken");
      //console.log("refreshToken:",refToken);
      return refreshToken()
        .then((collectionId) => {
          originalRequest.headers["collectionId"] = collectionId;
          Cookies.set("collectionId", collectionId, { expires: 7 });
          processQueue(null, collectionId);
          return axiosInstance(originalRequest);
        })
        .catch((err) => {
          processQueue(err, null);
          if (err.response.status === 302) {
            redirectToHome();
          }
          // redirectToHome();
          return Promise.reject(err);
        })
        .finally(() => {
          isRefreshing = false;
        });
    }
    //for access Api
    if (error.response.status === 403) {
      window.location.href = "/dashboard/403";
    }

    return Promise.reject(error);
  }
);

/**--------------------------------------------
 *               Queue for Controle Refresh
 *---------------------------------------------**/
const processQueue = (error, collectionId = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(collectionId);
    }
  });
  failedQueue = [];
};

/**--------------------------------------------
 *               Redirect When token expire
 *---------------------------------------------**/
const redirectToHome = () => {
  // Redirect to home page
  window.location.href = "/";
};

/**--------------------------------------------
 *               Refresh Token Fn
 *---------------------------------------------**/
const refreshToken = async () => {
  const refreshTokenUrl = `${baseApiUrl}/api/v1/Authentication/TokenValidation`;
  const collectionId = Cookies.get("collectionId");
  const response = await authAxios.post(
    refreshTokenUrl,
    {},
    {
      headers: {
        ...(collectionId && { collectionId }),
      },
    }
  );
  return response.data?.data;
};


export default axiosInstance;
